import { openSettingPage } from "@/utils/gaoding";
import { isEnter } from "@/utils/keyBoard";
import { Button, Dropdown, Input, Menu } from "antd";
import classNames from "classnames";
import lodash from "lodash";
import { useCallback } from "react";
import imageUrl from "../../utils/imageUrl";
import HBIcon from "../HBIcon";
import HBModel from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import ContactAvatar from "./components/ContactAvatar";
import MessageList from "./components/MessageList";
import styles from "./index.module.less";
import useViewModel, { CONVERSATION_TYPE } from "./viewModel";

const systemAvatar =
  "https://cdn.dancf.com/fe-assets/img/cd8cef63868baa9debd5eefafa7d93af.png";

/**
 * @param {
 * {
 *   targetUserId?: number;
 *   targetUserUrlname?: number;
 *   }
 * } props
 * @returns {JSX.Element}
 * @constructor
 */
export default function Chat(props) {
  const {
    user,
    blocked,
    conversations,
    current,
    content,
    msgList,

    onSendClick,
    onContentChange,
    onBlockClick,
    onDeleteConversation,
    onConversationClick,
    loadOldMessage,
    onReachBottom,
  } = useViewModel(props);

  // 快捷发送消息
  const onEnterSend = useCallback(
    (e) => {
      if (isEnter(e)) {
        if (e.metaKey || e.ctrlKey) {
          onSendClick();
        }
      }
    },
    [onSendClick]
  );

  if (lodash.isEmpty(user)) {
    return null;
  }

  return (
    <div className={styles.chat}>
      <div className={styles.chatblock1}>
        <div className={styles.headblock}>私信</div>
        <div
          className={classNames(
            styles.chatContainer,
            styles.avatars,
            "custom-scroll"
          )}
        >
          {current && (
            <>
              <div
                style={{
                  height: `${conversations.length * 80}px`,
                }}
              />
              {conversations.map((record, idx) => {
                const { _id_, unread, with_user, last_message, text, _type_ } =
                  record;

                const isSystem = _type_ === CONVERSATION_TYPE.SYSTEM;

                return (
                  <ContactAvatar
                    style={{ top: `${idx * 80}px` }}
                    isCurrent={
                      current._id_ === _id_ ||
                      current.with_user_id === with_user?.user_id
                    }
                    onClick={onConversationClick(record)}
                    key={_id_}
                    avatarUrl={
                      isSystem
                        ? systemAvatar
                        : with_user.avatar_url ||
                          imageUrl(with_user.avatar, {
                            width: 180,
                            rect: "sq",
                          })
                    }
                    message={isSystem ? text : last_message.text}
                    name={isSystem ? "系统通知" : with_user.username}
                    showRedPoint={!!unread}
                    urlname={with_user?.urlname}
                    onDelete={() => onDeleteConversation(record.with_user_id)}
                    hideClose={isSystem}
                  />
                );
              })}
            </>
          )}
        </div>
      </div>
      <div className={styles.chatblock2}>
        <div className={styles.headblock}>
          {current ? (
            current._type_ === CONVERSATION_TYPE.SYSTEM ? (
              "系统通知"
            ) : (
              <>
                <span>与 {current.with_user.username} 的私信</span>

                <Dropdown
                  overlayClassName={styles.chatDropdown}
                  overlay={
                    <Menu>
                      {/*<Menu.Item key="share">*/}
                      {/*  <div style={{ width: "100px" }}>*/}
                      {/*    <HBIcon type={"ic_share"} />*/}
                      {/*    &nbsp;&nbsp;分享*/}
                      {/*  </div>*/}
                      {/*</Menu.Item>*/}
                      {/*<Menu.Divider />*/}
                      <Menu.Item key="report" onClick={onBlockClick}>
                        加入黑名单
                      </Menu.Item>
                    </Menu>
                  }
                >
                  <HBIcon
                    type={"ic_arrow_down"}
                    style={{
                      width: "16px",
                      height: "16px",
                      display: "flex",
                      background: "white",
                      justifyContent: "center",
                      alignItems: "center",
                      marginLeft: "12px",
                      cursor: "pointer",
                      borderRadius: "4px",
                    }}
                  />
                </Dropdown>
              </>
            )
          ) : (
            ""
          )}
        </div>
        <div
          className={classNames(styles.chatContainer, styles.workspace)}
          key={current?._type_}
          {...(current?._type_ === CONVERSATION_TYPE.SYSTEM
            ? {
                "data-dialog-title": `私信-系统通知弹窗`,
                "data-gd-expose": "dialog_expose",
              }
            : {})}
        >
          <MessageList
            key={current?._id_}
            ref={msgList}
            onTopVisibleChange={loadOldMessage}
            onBottomVisibleChange={onReachBottom}
          />
          {current?._type_ === CONVERSATION_TYPE.CONTACT && (
            <div
              className={classNames(styles.input, {
                [styles.disabled]: blocked,
              })}
            >
              {blocked ? (
                blocked.startsWith("user") ? (
                  <>
                    <HBIcon
                      type={"ic_alert"}
                      style={{ fontSize: "16px", marginRight: "8px" }}
                    />{" "}
                    你已拉黑此用户，可以在
                    <span
                      style={{ color: "#FF5967" }}
                      onClick={() => {
                        openSettingPage(user, {
                          query: "tab=message",
                          page: "system",
                        });
                      }}
                    >
                      帐号设置
                    </span>
                    中解除对他对拉黑
                  </>
                ) : (
                  <>
                    <HBIcon
                      type={"ic_alert"}
                      style={{ fontSize: "16px", marginRight: "8px" }}
                    />{" "}
                    由于对方设置，你无法私信TA
                  </>
                )
              ) : (
                <div className={styles.inputArea}>
                  <Input.TextArea
                    placeholder={"请输入消息..."}
                    onChange={onContentChange}
                    value={content}
                    onKeyDown={onEnterSend}
                  />
                  <Button
                    type={"primary"}
                    disabled={!content}
                    onClick={onSendClick}
                    className={styles.sendBtn}
                  >
                    发送
                  </Button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/**
 * @param {{
 *   targetUserId?: number;
 *   targetUserUrlname?: string;
 * } & import("antd").ModalProps} props
 * @returns {JSX.Element}
 * @constructor
 */
export function ChatModal(props) {
  const { targetUserId, targetUserUrlname, ...rest } = props;

  return (
    <HBModel
      {...rest}
      footer={null}
      bodyStyle={{ padding: 0 }}
      width={850}
      destroyOnClose
    >
      <Chat targetUserId={targetUserId} targetUserUrlname={targetUserUrlname} />
    </HBModel>
  );
}

export const ChatDialog = ModalWrap(ChatModal);
